import {
    dropdownFieldConfigConstructor,
    numberFieldConstructor,
    rangeFieldConfigConstructor,
    switchFieldConstructor,
} from "scenes/cohort-filters/filter-configs/fieldContructors";
import { Category } from "scenes/cohort-filters/filter-configs/categories";

const therapyTypeOptions = [
    { value: "NONE", label: "anamnesis.hiv.NONE" },
    { value: "INSTI", label: "anamnesis.hiv.INSTI" },
    { value: "PI", label: "anamnesis.hiv.PI" },
    { value: "NNRTI", label: "anamnesis.hiv.NNRTI" },
];

const therapyMedicationOptions = [
    { value: "B_F_TAF", label: "anamnesis.hiv.B_F_TAF" },
    { value: "DTG_3TC", label: "anamnesis.hiv.DTG_3TC" },
    { value: "DTG_ABC_3TC", label: "anamnesis.hiv.DTG_ABC_3TC" },
    { value: "DTG_RPV", label: "anamnesis.hiv.DTG_RPV" },
    { value: "CAB_RPV", label: "anamnesis.hiv.CAB_RPV" },
    { value: "EVG_C_TAF_FTC", label: "anamnesis.hiv.EVG_C_TAF_FTC" },
    { value: "DRV_C_TAF_FTC", label: "anamnesis.hiv.DRV_C_TAF_FTC" },
    { value: "DOR_TDF_3TC", label: "anamnesis.hiv.DOR_TDF_3TC" },
    { value: "RPV_TAF_FTC", label: "anamnesis.hiv.RPV_TAF_FTC" },
    { value: "RPV_TDF_FTC", label: "anamnesis.hiv.RPV_TDF_FTC" },
    { value: "OTHER", label: "anamnesis.hiv.OTHER" },
];

export const hivFields = {
    ...switchFieldConstructor({
        category: Category.HIV,
        pathToValue: "anamnesis.hasHivDiagnosis",
        label: "anamnesis.hiv.hasHivDiagnosis",
    }),
    ...rangeFieldConfigConstructor({
        category: Category.HIV,
        pathToValue: "anamnesis.hivDiagnosisDate",
        label: "anamnesis.hiv.hivDiagnosisDate",
        isDate: true,
    }),
    ...numberFieldConstructor({
        category: Category.HIV,
        pathToValue: "anamnesis.hivTherapyCount",
        label: "anamnesis.hiv.hivTherapyCount",
    }),
    ...switchFieldConstructor({
        category: Category.HIV,
        pathToValue: "anamnesis.hasHivTherapyFailed",
        label: "anamnesis.hiv.hasHivTherapyFailed",
    }),
    ...dropdownFieldConfigConstructor({
        category: Category.HIV,
        pathToValue: "anamnesis.hivTherapyType",
        label: "anamnesis.hiv.hivTherapyType",
        dropdownValues: therapyTypeOptions,
    }),
    ...dropdownFieldConfigConstructor({
        category: Category.HIV,
        pathToValue: "anamnesis.hivTherapyMedication",
        label: "anamnesis.hiv.hivTherapyMedication",
        dropdownValues: therapyMedicationOptions,
    }),
};
